import { AutoIntegration } from '@givelify/api';
import { ReportType } from '../report/types';

export const SET_INTEGRATION = 'SET_INTEGRATION';
export const CLEAR_INTEGRATION = 'CLEAR_INTEGRATION';

export type IntegrationRequest = {
    data: {
        type: ReportType;
        doneeId: number;
        initialSetupStatus: string;
    };
};

export type AutoIntegrationUnmatched = {
    type: 'donors' | 'envelopes';
    count: number;
};

export interface AutoIntegrationState {
    data?: AutoIntegration;
    unmatchedEnvelopes?: number;
    unmatchedDonors?: number;
}

export interface SetIntegration {
    type: typeof SET_INTEGRATION;
    data: AutoIntegrationState['data'];
}

export interface ClearIntegration {
    type: typeof CLEAR_INTEGRATION;
}

export type IntegrationSecondActions = SetIntegration | ClearIntegration;
